import React, { forwardRef } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";

const CustomAutocomplete = forwardRef (
  (
    {
      value,
      onChange = ()=>{},
      defaultValue = null,
      options,
      multiple = false,
      loading = false,
      disabled = false,
      label = "",
      placeholder = "",
      error = false,
      helperText = "",
      size="small",
      shrink = true,
      sx = {},
      getOptionLabel = (option) => option.label ?? option,
      getOptionKey = (option) => option.label ?? option,
      isOptionEqualToValue = (option, value) => option === value,
      groupBy= null,
      renderOption = null,
      variant = "outlined",
      disableClearable = false,
    },
    ref
  ) => {
    return (
      <Autocomplete
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        defaultValue={defaultValue}
        options={options}
        multiple={multiple}
        disabled={disabled}
        loading={loading}
        size={size}
        sx={sx}
        getOptionKey={getOptionKey}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        groupBy={groupBy}
        renderOption={renderOption}
        disableClearable={disableClearable}
        
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            variant={variant}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="primary" size={20} disableShrink/> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
              inputLabel: {
                shrink: shrink,
              },
            }}
          />
        )}
        ref={ref}
      />
    )
  }
);

export default CustomAutocomplete;